import { FC, ReactNode, useState } from "react";

import { TenantClientSelectorContext } from "./useTenantClientSelector";

type TenantClientSelectorProviderProps = {
  children: ReactNode;
};

export const TenantClientSelectorProvider: FC<
  TenantClientSelectorProviderProps
> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [openedFromClientTrigger, setOpenedFromClientTrigger] = useState(false);

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    if (!nextOpen) setOpenedFromClientTrigger(false);
  };

  return (
    <TenantClientSelectorContext.Provider
      value={{
        open,
        setOpen: handleOpenChange,
        openedFromClientTrigger,
        setOpenedFromClientTrigger,
      }}
    >
      {children}
    </TenantClientSelectorContext.Provider>
  );
};
